module.exports = __webpack_public_path__ + "img/equip-pic3.30f6786a.png";